import api from "../../api"

export type UpdateConsultationRequest = {
  id: number
  customerId: number
  calendarEventId: number | null
  organizerEmail: string
  projectId: number | null
  timeFrame: string | null
  bestTimeToCall: string | null
  consultationDate: string
  fee: string | null
  salesLead: string | null
  emailTemplateGuid: string | null
  summary: string
  status: number
  description: string | null
  notes: string | null
  emailBody: string | null
}

export type ConsultationProject = {
  id: number
  name: string
  no: string
}

export type ConsultationProjectsResponse = {
  unscheduled: ConsultationProject[]
  scheduled: ConsultationProject[]
}

export const ConsultationStatuses = {
  Scheduled: 0,
  Pending: 1,
  Sold: 2,
  Lost: 3,
  Canceled: 4
} as const

export type ConsultationStatus = typeof ConsultationStatuses[keyof typeof ConsultationStatuses]

export const consultationStatusName = (status: ConsultationStatus): string => {
  return {
    [ConsultationStatuses.Scheduled]: 'Scheduled',
    [ConsultationStatuses.Pending]: 'Pending',
    [ConsultationStatuses.Sold]: 'Sold',
    [ConsultationStatuses.Lost]: 'Lost',
    [ConsultationStatuses.Canceled]: 'Canceled'
  }[status]
}

export const updateConsultation = async (consultation: UpdateConsultationRequest): Promise<void> => {
  await api.post(`/consultations/addEditConsultation`, consultation)
}

export const deleteConsultation = async (calendarEventId: number): Promise<void> => {
  await api.delete(`/calendar/${calendarEventId}`)
}

export const getConsultationProjects = async (customerId: number): Promise<ConsultationProjectsResponse> => {
  return (await api.get(`/customers/${customerId}/consultation-projects`)).data
}
